import { PdfTableCell } from '@/components/pdf/PdfTableCell';
import { styles } from '@/components/pdf/styles';
import { usePrintCurrencyString } from '@/utils/price';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import {
  PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_NAME_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_QTY_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH
} from './consts';

export interface PurchaseOrderCompleteDocumentDeviceFeesTableData {
  name: string;
  qty: number;
  price: number;
  totalPrice: number;
}

interface PurchaseOrderCompleteDocumentDeviceFeesTableProps {
  data: PurchaseOrderCompleteDocumentDeviceFeesTableData[];
  regionCode?: string;
}

const PurchaseOrderCompleteDocumentDeviceFeesTable: FunctionComponent<
  PurchaseOrderCompleteDocumentDeviceFeesTableProps
> = ({ data, regionCode }) => {
  const printCurrencyString = usePrintCurrencyString({ regionCode });

  return (
    <View
      style={{
        ...styles.table,
        width: PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH * 2,
        marginTop: 20
      }}
    >
      <View style={styles.tableRow}>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_NAME_CELL_WIDTH} height={20}>
          <Text style={styles.tableHeaderCell}>Device Name</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_QTY_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Qty</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Unit Fee</Text>
        </PdfTableCell>
        <PdfTableCell lastCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Total Fee</Text>
        </PdfTableCell>
      </View>
      {data.map((item, index) => {
        const formattedPrice = printCurrencyString(item.price);
        const formattedTotalPrice = printCurrencyString(item.totalPrice);

        return (
          <View style={styles.tableRow} key={`${item.name}-${index}`}>
            <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_NAME_CELL_WIDTH} height={20}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </PdfTableCell>
            <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_QTY_CELL_WIDTH}>
              <Text style={styles.tableCell}>{item.qty}</Text>
            </PdfTableCell>
            <PdfTableCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH}>
              <Text style={styles.tableCell}>{formattedPrice}</Text>
            </PdfTableCell>
            <PdfTableCell lastCell width={PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH}>
              <Text style={styles.tableCell}>{formattedTotalPrice}</Text>
            </PdfTableCell>
          </View>
        );
      })}
    </View>
  );
};

export default PurchaseOrderCompleteDocumentDeviceFeesTable;
